module.exports = __webpack_public_path__ + "img/6741ff9.png";